<template>
  <div id="ProjBidNewInfo">
    <ProjBidNewHeader @beforeRouteChange="saveOrEditProject(false)"/>
    <ProjectEditSummary :project.sync="project" class="panel-box" />
    <div class="eb-line"></div>
    <ProjBidNewProcurementMethod :project.sync="project" class="panel-box" />
    <div class="eb-line"></div>
    <div class="eb-button-group">
      <el-button :loading="buttonLoading" class="eb-button-group-btn eb-button-orange eb-button-big" @click="saveOrEditProject(false)">保存草稿</el-button>
      <el-button :loading="buttonLoading" class="eb-button-group-btn eb-button-orange eb-button-big" @click="saveOrEditProject(true)">采购规则 &gt;</el-button>
    </div>
  </div>
</template>

<script>
import ProjBidNewHeader from '@/components/project/bid/new/ProjBidNewHeader';
import ProjectEditSummary from '@/components/project/common/ProjectEditSummary';
import moment from 'moment';
import { getProjectById, saveProject, newProject, editProject } from '@/services/proj/bid-project-service';
import ProjBidNewProcurementMethod from '@/components/project/bid/new/ProjBidNewProcurementMethod';
export default {
  name: 'ProjBidNewInfo',
  components: {
    ProjBidNewHeader,
    ProjectEditSummary,
    ProjBidNewProcurementMethod
  },
  data() {
    return {
      user: this.$store.state.user.userInfo,
      project: {
        templateName: '',
        templateId: '',
        projectCode: '',
        projectType: '1',
        resultPublic: '1',
        startType: '1',
        endTime: '',
        projectStyle: '1',
        bidProjectArea: '',
        bidProjectOpenTime: '',
        durationDays: '0',
        projectName: '',
        projectInfo: '',
        projectId: '',
        startTime: ''
      },
      newProjectCode: null,
      buttonLoading: false
    };
  },
  created() {
    var projectId = this.$route.params.projectId;
    if (projectId) {
      this.initProjectFind({ projectId: projectId, userId: this.user.userid });
    } else {
      this.initProjectNew();
    }
  },
  methods: {
    async initProjectFind(params) {
      this.$root.layout.isLoading = true;
      try {
        let { data } = await getProjectById(params);
        if (data.returnCode === '01') {
          for (let i in this.project) {
            this.project[i] = data.project[i];
          }
          this.project.startType = this.project.startType + '';
          if (this.project.startTime === 32503651200000) {
            this.project.startTime = '';
          }
        } else {
          this.$message.error('获取项目信息失败');
        }
      } catch (error) {
        this.$message.error(error.message);
      }
      this.$root.layout.isLoading = false;
    },
    async initProjectNew() {
      this.$root.layout.isLoading = true;
      try {
        let { data } = await newProject();
        if (data.returnCode === '01') {
          this.project.projectCode = data.projectCode;
          this.newProjectCode = data.projectCode;
        } else {
          this.$message.error('获取项目编号失败');
        }
        this.$root.layout.isLoading = false;
      } catch (error) {
        this.$root.layout.isLoading = false;
        this.$message.error(error.message);
      }
    },
    saveOrEditProject: function(isLink) {
      this.buttonLoading = true;
      if (!this.validate()) {
        this.buttonLoading = false;
        return;
      }
      var params = {};
      for (var i in this.project) {
        params[i] = this.project[i];
      }
      params.createId = this.user.userid;
      params.buyUserId = this.user.userid;
      params.buyDepartId = this.user.departId;
      params.projectStatus = 1;
      delete params.templateName;
      params.bidProjectOpenTime = this.$options.filters['dateTimeStandardFormat'](params.bidProjectOpenTime);
      params.startTime = this.$options.filters['dateTimeStandardFormat'](parseInt(params.startTime));
      params.endTime = this.$options.filters['dateTimeStandardFormat'](params.endTime);
      if (params.startType === '1') {
        params.startTime = this.$options.filters['dateTimeStandardFormat']('3000-01-01');
      }
      if (params.projectStyle === 1 && params.bidProjectArea === '') {
        params.bidProjectArea = '采购方所在地';
      }

      if (this.project.projectId) {
        this.editProject(params, isLink);
      } else {
        params.buyScope = 3;
        this.saveProject(params, isLink);
      }
    },
    async editProject(params, isLink) {
      delete params.buyDepartId;
      delete params.buyUserId;
      delete params.createId;
      params.updateId = this.user.userid;
      let { data } = await editProject(params);
      this.responseData(data, isLink);
    },
    async saveProject(params, isLink) {
      let { data } = await saveProject(params);
      this.responseData(data, isLink);
    },
    responseData: function(data, isLink) {
      this.buttonLoading = false;
      if (data.returnCode === '01') {
        this.$message.success('保存成功');
        if (!this.project.projectId && !isLink) {
          this.project.projectId = data.projectId;
          this.$router.push('/projbid/new/info/' + data.projectId);
        }
        if (isLink) {
          this.$router.push('/projbid/new/ruleedit/' + data.projectId);
        }
      } else {
        if (data.returnCode === '00') {
          this.$message.error('输入的信息超长或不符合要求，请进行修改。');
        }
        if (data.returnCode === '04') {
          this.$message.error('项目编号重复，请进行修改');
        }
      }
    },
    validate: function() {
      if (!this.project.projectCode) {
        this.$message.error('项目编号不能为空，已为您恢复为系统默认编号');
        this.project.projectCode = this.newProjectCode;
        return false;
      }
      if (this.project.projectCode.indexOf(' ') !== -1) {
        this.$message.error('项目编号中间不能有空格');
        return false;
      }
      if (this.project.projectCode.length > 20) {
        this.$message.error('项目编号长度不能超过20个字符');
        return false;
      }
      if (!this.project.projectName) {
        this.$message.error('请输入项目名称');
        return false;
      }
      if (this.project.startType === '2') {
        if (this.project.startTime === 32503651200000) {
          this.$message.error('请选择正确的开始时间');
          return false;
        }
        if (this.project.startTime < moment()) {
          this.$message.error('开始时间必须大于当前时间');
          return false;
        }
      }
      if (!this.project.endTime) {
        this.$message.error('请选择正确的截标时间');
        return false;
      }
      if (this.project.endTime < moment()) {
        this.$message.error('截标时间必须大于当前时间');
        return false;
      }
      if (!this.project.bidProjectOpenTime) {
        this.$message.error('请选择正确的开标时间');
        return false;
      }
      if (!this.project.bidProjectOpenTime) {
        this.$message.error('开标时间必须大于当前时间');
        return false;
      }
      if (this.project.bidProjectOpenTime < this.project.endTime) {
        this.$message.error('开标时间不能早于截标时间');
        return false;
      }
      if (this.project.startType === '2' && this.project.endTime <= this.project.startTime) {
        this.$message.error('截标时间必须大于开始时间');
        return false;
      }
      return true;
    }
  }
};
</script>

<style scoped lang="less">
</style>
